/* eslint-disable no-param-reassign */
import { openNotificationToast } from 'Utils/notificationMessageUtils.jsx';
import { useGlobal } from './reactn/useGlobal';
import counterpart from 'counterpart';

const useAlert = () => {
    const [alerts, setAlerts] = useGlobal('alertData');

    const deleteAlert = (targetIndex) => {
        const filteredAlerts = alerts.preferences.filter((alert, index) => index !== targetIndex);
        setAlerts(newAlerts => {
            newAlerts.preferences = filteredAlerts || [];
        });
    };

    const postAlert = () => {
        const notificationMessageSuccess = {
            type: 'info',
            placement: 'topRight',
            messageWidth: 600,
            byDefault: true,
            duration: 5,
            content: counterpart('globalTranslate.sessionTimeout.renewSuccess'),
          }
          openNotificationToast(notificationMessageSuccess);
    };

    return {
        alerts: 'chnages',//alerts.preferences,
        postAlert,
        deleteAlert,
    };
};

export default useAlert;
